// Which bookmark a rename goes on (Josh's QA, 25 Oct 2026). In a saved version the list shows the version's own
// bookmarks, so the name goes there; in the live show it goes on my bookmarks.
export function bookmarkRename(versionID, page, title) {
    return versionID
        ? ['updateVersionBookmark', { versionID, page, title }]
        : ['updateBookmark', { page, title }];
}

// The bookmarks that count on the page (its ribbon): in a saved version only that version's own, none when it was saved
// without any; the live show's otherwise (Josh's QA, 25 Oct 2026: versions showed the live show's bookmarked pages).
export function bookmarksShown(currentVersion, liveBookmarks) {
    if (currentVersion && currentVersion.id) return currentVersion.bookmarks || {};
    return liveBookmarks || {};
}

export default { bookmarkRename, bookmarksShown };


// WEBPACK FOOTER //
// ./src/lib/bookmark-rename.js